export const CRITICAL = 'critical';
export const INFO = 'info';
